import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'acc-card-body',
  imports: [
    NgClass
  ],
  templateUrl: './card-body.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-body.component.scss'
})
export class CardBodyComponent {

  @Input()
  public size: 'sm' | undefined;

  @Input()
  public accClass: string = '';
}
